
// Import css files

import sandhl from '../../../../../assets/images/b1iconset.png';
import bankingicon from '../../../../../assets/askTheExpertImages/bankingicon.svg';
import React from 'react';

import { decodeHtmlEntities } from "../../../../../shared/helper";

const BankingArticleDetailsV4Jsx = (props) => {
  const {
    detailsData
  } = props;
  return (
    <>
  <section className="bankinversionfourdetailblog">
        <div className="container">
          <div className="blogsectioone">
            <div className="row">
            <div className="col-lg-7 col-sm-7">
            <div className="tagreal"><span><img src={bankingicon} alt="Banking Icon" /></span>{detailsData?.['_embedded']?.['wp:term']?.[0]?.[0]?.name}</div>
            <div className="blogsectioleft">
              <div className="title">
                <h1>{decodeHtmlEntities(detailsData?.title?.rendered)}</h1></div>
              <p>{detailsData?.acf?.variant_4?.banner_sectionn?.description}</p>
            </div>
            <div className="d-flex userdetails">
              <div className="userphoto">
                <img src={`https://ui-avatars.com/api/?name=${detailsData?.['_embedded']?.['author']?.[0]?.name}&rounded=true`} alt={`${detailsData?.['_embedded']?.['author']?.[0]?.name}`} />
              </div>
              <div className="username">{detailsData?.['_embedded']?.['author']?.[0]?.name}</div>
            </div>
            </div>
            <div className="col-lg-5 col-sm-5">
              <div className="blogsectioright">
                <img src={detailsData?.acf?.variant_4?.banner_sectionn?.image} alt="bannermage"/>
             
              </div>
              </div>
            </div>
           
          </div>
         
         
          <div className="blogsectiofour">
            <h2>{detailsData?.acf?.variant_4?.overview_section?.title} </h2>
            <p>{detailsData?.acf?.variant_4?.overview_section?.description}  </p>
            <div className="row">
            {detailsData?.acf?.variant_4?.overview_section?.guide.map((item,index) => (
              <div className="col" key={index}>
                <div className="blogsectiofourinner">
                  <div className="serialnumber">{ String(index+1).padStart(2, '0')}</div>
                  <h4>{item?.title} </h4>
                  <p>{item?.description}</p>
                </div>
              </div>
              ))}

              
            </div>
           
          </div>
          <div className="blogsectiofive">
            <div className="row">
              <div className="col-lg-6 col-sm-6 flb">
              <div className="blogsectiofiveleft">
              <div className="blogsectiofiveinner">
                 <h2>{detailsData?.acf?.variant_4?.avoid_mistake_section?.title} </h2>
                <p>{detailsData?.acf?.variant_4?.avoid_mistake_section?.description} </p>
              </div>
              <div className="blogsectiofiveimage"><img src={detailsData?.acf?.variant_4?.avoid_mistake_section?.image} alt="blogimage" /></div>
              </div>
              </div>
              <div className="col-lg-6 col-sm-6">
              <div className="blogsectiofivemiddle">
              <div className="blogsectiofivemiddleinner">
                  <ul>
                  {detailsData?.acf?.variant_4?.avoid_mistake_section?.item.map((item,index)=>(
                    <li key={index}>
                     <h4>Step {index} : {item?.title}</h4>
                      <p>{item?.description}</p>
                    </li>
                    ))}
                   
                  </ul>
                 
              </div>
     
              </div>
              </div>
             
            </div>
          </div>
          <div className="blogsectiothree">
           
            <div className="row">
             
              <div className="col-lg-12 col-sm-1">
                <div className="blogsectiothreeright">
                 <h2>{detailsData?.acf?.variant_4?.tips_section?.title} </h2>
                  <ul>
                  {detailsData?.acf?.variant_4?.tips_section?.tips.map((item,index)=>(
                    <li key={index}>
                      <span>{String.fromCharCode(65 + index)}</span>
                      <h4>{item?.title}</h4>
                      <p>{item?.description}</p>
                    </li>
                    ))}
                   
                  </ul>
                </div>
              </div>
            </div>
            
          </div>
          <div className="blogsectiosix">
            <div className="row">
            <div className="col-lg-6 col-sm-6">
                <div className="blogsectiotwoinner">
                  <h2><span><img src={sandhl} alt="blogimage"/></span>{detailsData?.acf?.variant_4?.checklist_section?.title}</h2>
                  <ul>
                  {detailsData?.acf?.variant_4?.checklist_section?.item.map((item,index)=>(
                    <li key={index}>{item?.title}</li>
                    ))}
                   
                  </ul>
                </div>
            </div>
            <div className="col-lg-6 col-sm-6">
            <div className="blogsectiofiveimageset"><img src={detailsData?.acf?.variant_4?.checklist_section?.image} alt="blogimage" /></div>
            </div>
            </div>
         
            </div>
          <div className="blogsectiotwo">
          <div className="blogsectiotwoinner">
            <h2>{detailsData?.acf?.variant_4?.conclusion_section?.title}</h2>
            <div dangerouslySetInnerHTML={{ __html: detailsData?.acf?.variant_4?.conclusion_section?.description }}></div>
            
          </div>
          </div>
        </div>
      </section>
    </>

  );
};

export default BankingArticleDetailsV4Jsx;
